var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-link-area"},[(_vm.image)?_c('img',{attrs:{"src":_vm.image,"alt":""}}):_c('p',{staticClass:"unit-empty"})])
}
var staticRenderFns = []

export { render, staticRenderFns }